export default __webpack_public_path__ + "static/media/fondopdf.c8a1b370.png";